<template>
  <div class="contact-page">
    <section class="contact-hero">
      <div><span>{{ isEnglish ? 'CONTACT' : '联系我们' }}</span><h1>{{ $t('contact.title') }}</h1><p>{{ intro }}</p></div>
      <img src="/images/contact.jpg" :alt="$t('contact.title')">
    </section>
    <section class="contact-content">
      <div class="people-panel">
        <span class="section-label">{{ isEnglish ? 'GET IN TOUCH' : '商务联系' }}</span>
        <div v-for="(person, index) in visiblePeople" :key="index" class="person-card">
          <div class="person-heading"><span>0{{ index + 1 }}</span><h2>{{ person.name.value }}</h2></div>
          <dl>
            <div><dt>{{ person.changer.name }}</dt><dd>{{ person.changer.value }}</dd></div>
            <div><dt>{{ person.tel.name }}</dt><dd><a :href="`tel:${person.tel.value}`">{{ person.tel.value }}</a></dd></div>
            <div><dt>{{ person.email.name }}</dt><dd><a :href="`mailto:${person.email.value}`">{{ person.email.value }}</a></dd></div>
          </dl>
        </div>
      </div>
      <div class="address-panel">
        <span class="section-label">{{ isEnglish ? 'OUR LOCATIONS' : '办公地点' }}</span>
        <article v-for="(address, index) in addresses" :key="index">
          <span>0{{ index + 1 }}</span><div><h3>{{ address.addrName }}</h3><strong>{{ address.companyName }}</strong><p>{{ address.addr }}</p></div>
        </article>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: 'Contact',
  data() { return { showMid: true }; },
  computed: {
    isEnglish() { return this.$i18n.locale.indexOf('en') !== -1; },
    intro() { return this.isEnglish ? 'Talk with our team about smart hardware, product solutions, and collaboration.' : '欢迎联系我们，了解智能硬件、产品方案与合作机会。'; },
    people() { return this.$t('contact').items; },
    visiblePeople() { return this.showMid ? this.people : this.people.slice(0, 1); },
    addresses() { return this.$t('contact').address; }
  },
  mounted() {
    this.showMid = window.location.href.indexOf('mltcloud.com') === -1;
    document.body.className = 'site-page';
  }
};
</script>
<style lang="stylus" scoped>
.contact-page
  color #111c39
  background #f6f8fc
.contact-hero
  max-width 1440px
  min-height 500px
  margin 0 auto
  padding 72px 48px 76px
  display grid
  grid-template-columns .72fr 1.28fr
  align-items center
  gap 70px
  div > span
    color #3566d4
    font-size 11px
    font-weight 750
    letter-spacing .18em
  h1
    margin 16px 0 18px
    font-size clamp(48px,6vw,78px)
    letter-spacing -.055em
  p
    margin 0
    color #66738d
    font-size 17px
    line-height 1.8
  img
    display block
    width 100%
    aspect-ratio 1.75
    object-fit cover
    border-radius 28px
    box-shadow 0 28px 65px rgba(29,48,96,.18)
.contact-content
  max-width 1440px
  margin 0 auto
  padding 95px 48px 110px
  display grid
  grid-template-columns 1fr 1fr
  gap 26px
  background #fff
.people-panel,.address-panel
  padding 34px
  border 1px solid #e3e8f2
  border-radius 24px
  background #f8faff
.section-label
  display block
  margin-bottom 25px
  color #3566d4
  font-size 11px
  font-weight 750
  letter-spacing .16em
.person-card
  padding 24px 0
  border-top 1px solid #dfe5ef
  &:last-child
    padding-bottom 0
.person-heading
  display flex
  align-items baseline
  gap 14px
  span
    color #71809d
    font-size 11px
  h2
    margin 0
    font-size 21px
dl
  margin 18px 0 0 29px
  div
    display grid
    grid-template-columns 110px 1fr
    gap 14px
    margin-top 10px
    font-size 14px
  dt
    color #8490a7
  dd
    margin 0
    color #35425e
  a
    color #285ccf
    text-decoration none
.address-panel article
  display grid
  grid-template-columns 35px 1fr
  gap 14px
  padding 24px 0
  border-top 1px solid #dfe5ef
  > span
    color #71809d
    font-size 11px
  h3
    margin 0 0 10px
    font-size 19px
  strong
    display block
    color #35425e
    font-size 14px
    line-height 1.6
  p
    margin 8px 0 0
    color #77839a
    font-size 14px
    line-height 1.7
@media (max-width: 850px)
  .contact-hero
    grid-template-columns 1fr
    padding 58px 24px 70px
  .contact-content
    padding 76px 24px 84px
    grid-template-columns 1fr
@media (max-width: 560px)
  .contact-hero,.contact-content
    padding-left 20px
    padding-right 20px
  .people-panel,.address-panel
    padding 25px 20px
  dl
    margin-left 0
    div
      grid-template-columns 1fr
      gap 3px
</style>
